import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { EventInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import * as global from '../global'
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router, ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from 'src/app/services/auth.service';
import { DashboardService } from '../dashboard/dashboard.service';
import { PatientListService } from '../patient-list/patient-list-service';
import * as moment from "moment";
import { CreateCensusCalenderComponent } from '../create-census-calender/create-census-calender.component';
import { CensusCalenderService } from './census-calender.service';
import { CommonService } from 'src/app/services/common.service';
import Tooltip from 'tooltip.js';
import { PatientAddService } from '../patient-add/patient-add-service';
import { FormControl, FormGroup } from '@angular/forms';
import { TranscriptionCreateService } from '../transcription-create/transcription-create.service';
import { CensusListService } from '../census-list/census-list..service';
import { lastValueFrom } from 'rxjs';
import { CompanyService } from 'src/app/services/Modules/company.service';

@Component({
  selector: 'app-census-calender',
  templateUrl: './census-calender.component.html',
  styleUrls: ['./census-calender.component.css']
})
export class CensusCalenderComponent implements OnInit, OnChanges {
  now = new Date();
  admin: Boolean = false;
  company: Boolean = false;
  @ViewChild('calendar') calendarComponent: FullCalendarComponent;
  calendarPlugins = [dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin];
  header = {
    left: 'today  prev,next',
    center: 'title',
    right: 'dayGridMonth, dayGridDay'
  };
  header_ = {
    left: 'today prev,next',
    center: 'title',
    right: 'dayGridMonth,timeGridWeek,dayGridDay,listWeek'
  };

  titleFormat = { year: 'numeric', month: 'long' };
  calendarWeekends = true;
  calendarEvents: EventInput[];
  views = {
    month: {
      eventLimit: 4
    },
    //   customWeek: {
    //     type: 'timeline',
    //     duration: { weeks: 1 },
    //     slotDuration: {days: 1},
    //     buttonText: 'Custom Week'
    // }
  };
  selectInfo = {
    start: this.now
  };
  currentDate = new Date();
  test_time = '12:00 AM';
  minTime = moment().format('LT');
  @Input('data') data: any;
  appointmentId = '';
  currentUser: any;
  facility_id: any;
  currentUserDetails: { id: any; auth_key: any; usertype: any; };
  censuses: any;
  providerIdParam: any;
  filter_provider_id: any;
  providers: any;
  provider_id: any;
  facilities: any;
  selectedFacility: any;
  searchText: any;
  searchTextP: any;
  filter_date={
    month: null,
    year:null
  };
  filterFormGroup: FormGroup;
  @Output() refreshCounts = new EventEmitter<any>();
  censusOpened: boolean = false;
  allowImporting: boolean = false;

  constructor(
    private _patientListService: PatientListService,
    private _authService: AuthService,
    private _censusListService: CensusListService,
    private commonService: CommonService,
    private dialog: MatDialog,
    private toastr: ToastrService,
    private loader: NgxUiLoaderService,
    private dashboardService: DashboardService,
    private _transcriptionCreateService: TranscriptionCreateService,
    private router: Router,
    private route: ActivatedRoute,
    private _patientAddService: PatientAddService,
    private _censusCalenderService: CensusCalenderService
  ) {

    this.currentUser = this._authService.currentUser;
    this.allowImporting = this.currentUser.permissions.some(permission => permission.key === "add_patients_to_census");
    this.currentUserDetails = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type
    }
    this.providerIdParam = this.currentUser._id;

    if (this.data?.provider_id) {
      this.provider_id = this.data.provider_id;
    } else {
      this.provider_id = this.providerIdParam;
    }
    if (this.data?.facility_id) {
      this.facility_id = this.data.facility_id;
    } else {
      this.facility_id = null;
    }
    this.filterFormGroup = new FormGroup({
      facility: new FormControl(null),
      provider: new FormControl(null),

    });
    this.searchText = '';
    this.searchTextP = '';
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.data) {
      this.provider_id = changes.data.currentValue.provider_id;
      this.facility_id = changes.data.currentValue.facility_id;
      if (this.provider_id && this.provider_id != 'none') {
        this.loadData(this.provider_id, this.facility_id);
      } else if (this.provider_id == 'none' && this.facility_id == 'none') {
        this.calendarEvents = [];
        this.censuses = [];
      }
    }
  }

  tooltipEvent(info) {

      if (info.event.extendedProps.imageurl) {
          let imageurl = info.event.extendedProps.imageurl;
          let title = $(info.el).find('.fc-title');

          title.prepend("<img src='" + imageurl +"' width='17' height='15' style='margin-right:5px'>");
      }
    let calender = document.getElementById('calender');
    const instance = new Tooltip(info.el, {
      title: info.event.extendedProps.description,
      html: true,
      placement: 'auto-start',
      trigger: 'hover',
      container: '#calender'
    });

  }


  handleDatesRender(event) {
    const selectedDate = event.view.title;
    this.filter_date.month = this.getMonthNumber(selectedDate);
    this.filter_date.year = this.getYearFromString(selectedDate);
    // Attach click event listeners to the next and previous buttons
    const prevButton = document.querySelector('.fc-prev-button');
    const nextButton = document.querySelector('.fc-next-button');

    if (prevButton) {
      prevButton.addEventListener('click', () => {
        console.log('Previous button clicked');
        this.loadData(this.provider_id, this.facility_id?this.facility_id._id:null);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', () => {
        console.log('Next button clicked');
        this.loadData(this.provider_id, this.facility_id?this.facility_id._id:null);
      });
    }


    console.log('Selected Date:', selectedDate, event.view);

  }

  getMonthNumber(monthName) {
    const monthNames: { [key: string]: number } = {
      jan: 1, january: 1,
      feb: 2, february: 2,
      mar: 3, march: 3,
      apr: 4, april: 4,
      may: 5,
      jun: 6, june: 6,
      jul: 7, july: 7,
      aug: 8, august: 8,
      sep: 9, september: 9,
      oct: 10, october: 10,
      nov: 11, november: 11,
      dec: 12, december: 12
    };
  
    monthName = monthName.toLowerCase().replace(/[^a-z]/g, '');
    const monthNumber = monthNames[monthName] || null;
  
    return monthNumber;
  }

  getYearFromString(dateString) {
    const yearPattern = /(\d{4})/; // Matches a sequence of 4 digits (year)

    const match = dateString.match(yearPattern);
    if (match) {
      const year = parseInt(match[0], 10);
      return year;
    } else {
      return null; // Return null if no year is found in the input string
    }
  }

  async loadFacilities(provider_id) {
    let facres = await this._patientAddService.getFacilities({ doctor_id: provider_id }).subscribe((res: any) => {
      let response = res.data?.array;
      if (response) {
        this.facilities = response;
        const selectedFacility = localStorage.getItem('censusCalendarFacility');
        if (selectedFacility) {
          this.facility_id = this.facilities.find(f => f._id?.toString() == JSON.parse(selectedFacility)._id?.toString());
        } else {
          this.filterFormGroup.get('facility').setValue('all');
        }
      } else {
        console.log("something went wrong!");
      }
    });
  }

  clearInput() {
    this.searchText = '';
  }

  clearInputP() {
    this.searchTextP = '';
  }

  async ngOnInit(): Promise<void> {
    if (window.location.pathname.includes('admin')) {
      this.admin = true;
    }
    else if (window.location.pathname.includes('company')) {
      this.company = true;
    }
    else {
      this.admin = false;
      if (this.currentUser.user_type == global.USER_TYPE.DOCTOR || this.currentUser.user_type == global.USER_TYPE.SNF_WC_NURSE) {
        let response: any = await this.dashboardService.getP2PRelation().toPromise()
        if (response.status == 200) {
          this.providers = [this.currentUser].concat(response.data.assoc_provider_id);
          this._censusListService.castFilterProviderId.subscribe(filterProviderId => {
            if(filterProviderId){
              this.provider_id = filterProviderId;
              this.refreshCounts.emit(this.provider_id);
            }else{
              this.provider_id = this.providers[0]._id;
              this.refreshCounts.emit(this.provider_id);
            }
            this.filterFormGroup.get('provider').setValue(this.provider_id);
            this.loadFacilities(this.provider_id);
          })

          this.commonService.sortProviderDropdown(this.providers);
        }
      }
      else if (this.currentUser.user_type == global.USER_TYPE.MEDICAL_ASSISTANT) {
        this.initAssociatedProvidersListForMA();
      }
      else if (this.currentUser.user_type == global.USER_TYPE.BUSINESS_OFFICER) {
        this.initAssociatedProvidersListForBO();
      }
      else {
        this.initAssociatedProvidersList();
      }
      this.filterFormGroup.get('provider').valueChanges.subscribe(async (val) => {
        this.provider_id = val;
        this.refreshCounts.emit(this.provider_id);
        await this.loadFacilities(this.provider_id);
      });
      this.filterFormGroup.get('facility').valueChanges.subscribe((val) => {
        if (val == 'all')
          this.facility_id = null;
        else{
          this.facility_id = val;
        }
        this.loadData(this.provider_id, this.facility_id?._id);
      });

    }
  }

  ngOnDestroy(): void {
    this._censusListService.changeFilterProviderId(this.provider_id);
    // this._censusListService.changeFilterFacilityId(this.facility_id?._id);
    if(!this.censusOpened) {
      localStorage.removeItem('censusCalendarFacility');
    }
  }
  navigateCalenderToDate(date) {
    const calendarApi = this.calendarComponent.getApi();
    calendarApi.changeView('dayGridMonth', date);
  }
  getBackgroundColor(element) {
    return 'red';
  }
  showPatientRoundingSheetDialog(calender_date) {

    const obj = {
      filter_facility_id: this.facility_id?this.facility_id._id:null,
      filter_provider_id: this.provider_id ? this.provider_id : this.currentUser._id,
      calender_date: calender_date
    }
    const dialogRef = this.dialog.open(CreateCensusCalenderComponent, {
      data: obj,
      width: '50%'
    });
    dialogRef.afterClosed().subscribe(async (data) => {
      
      if (data)
        this.loadData(this.provider_id, this.facility_id?this.facility_id._id:null);
    });
  }

  handleDateClick(arg) {

    if (!(this.company))

      if (arg.date) {
        //
        let clickedDate = moment(arg.date).format('L');
        let momentDate = moment().format('L');
        if (moment(clickedDate).isSame(momentDate)) {
          this.minTime = moment().format('LT');
          this.test_time = this.minTime;
        } else if (moment(clickedDate).isBefore(momentDate)) {
          return;
        } else if (moment(clickedDate).isAfter(momentDate)) {
          this.minTime = '0:00 AM';
          this.test_time = this.minTime;
        }
        if (this.allowImporting) this.showPatientRoundingSheetDialog(arg.date);
        this.test_time = arg.date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      }
  }

  handleEventClick(arg) {
    this.viewClicked(arg.event.extendedProps._id);
  }

  toolTipInfo(e) {
    let totalPatients = e.patientList?.length || 0;
    let savedNotesCount = e.savedNotesCount || 0;
    let signedNotesCount = e.signedNotesCount || 0;
    let draftChargesCount = e.draftChargesCount || 0;
    let submittedChargesCount = e.submittedChargesCount || 0;
    let totalInActivePatients = e.patientsInactive?.length || 0;
    let totalActivePatients = totalPatients - totalInActivePatients;

    let totalSeenPatients = e.patientsSeen?.length || 0;
    let is_void = e.is_void ? 'Yes' : 'No';


    let toolText = `Census Name: <strong>${e?.name}</strong> </br>  
                    Total Patients: <strong>${totalPatients}</strong> </br>
                    Saved Notes: <strong>${savedNotesCount}</strong> </br>
                    Signed Notes: <strong>${signedNotesCount}</strong> </br>
                    Drafted Charges: <strong>${draftChargesCount}</strong> </br>
                    Submitted Charges: <strong>${submittedChargesCount}</strong> </br> `;

    // let toolText=` Census Name: <strong>${e?.name}</strong> </br> Facility: <strong>${e.facility?.title}</strong> </br> Total Patients: <strong>${totalPatients}</strong> 
    //   </br> InActive Patients: <strong>${totalInActivePatients}</strong> </br> Active Patients: <strong>${totalActivePatients}</strong>
    //   </br> Seen Patients: <strong>${totalSeenPatients}</strong> </br> Void Census: <strong>${is_void}</strong> `;

    return toolText;
  }

  async getCensuses(provider_id = this.currentUser._id, facility_id = null) {
    if((provider_id == this.currentUser._id)&&this.currentUser.user_type!='1'&&facility_id==null) return;

    return new Promise<void>((resolve, reject) => {
    
      this._censusCalenderService.getCensuses({ provider_id: provider_id, facility_id: facility_id, filter_date:this.filter_date }).subscribe((resp: any) => {
        if(resp?.data?.length>0){
          this.censuses = resp.data;

            this.calendarEvents = resp.data.map(e => {
              let facility_title = e?.facility?.title;
              // e.title = `${e?.name} \n ${facility_title}`;
              // e.description = `${e?.name} / ${facility_title}`;
    
              e.title = `${facility_title}`;
              e.description = this.toolTipInfo(e);

              if(e?.facility?.source=='PointClickCare' || e?.facility?.pcc_facId){
                e.imageurl= '../../../assets/icons/pcc-icon.svg';
              }else if(e?.facility?.source=='MatrixCare'){
                e.imageurl= '../../../assets/icons/matrix.png';
              }else {
                e.imageurl= '../../../assets/img/DN.png';
              }

              e.start = this.commonService.dateObjToString_calenderFormat(e.date_obj);
              e.id = `${e?._id}`;
              e.title_id = `${e?._id}`;
              e.allDay = true;
              e.color = this.applyRowColors(e);
              e.textColor = 'darkslategrey';
              e.borderColor = 'darkgray';

              return e;
            })

        }
        resolve();
      }, error => {
        reject('error => ' + error.toString());
      });
    });
  }

  applyRowColors(row) {
    let past = '#eeeeee';
    let future = '#bac5f5';
    let present = '#c0face';
    if (row.date_obj) {

      const censusDate = new Date(`${row.date_obj?.year||new Date(row?.createdAt).getFullYear()}-
                    ${row.date_obj?.month||new Date(row?.createdAt).getMonth()}-
                    ${row.date_obj?.day||new Date(row?.createdAt).getDate()}`).getTime();

      const currentDate = new Date();
      let day = currentDate.getDate();
      let month = currentDate.getMonth();
      let year = currentDate.getFullYear();
      const currentDateFormat = new Date(`${year}-${month + 1}-${day}`).getTime();
      if (censusDate < currentDateFormat) {
        return past;
      }
      else if (censusDate == currentDateFormat) {
        return present
      } else if (censusDate > currentDateFormat) {
        return future
      }
    }
    if (row.date && !row.date_obj) {
      let currentDate = new Date().toISOString();
      if (row.date < currentDate) {
        return past;
      }
    }
  }

  async loadData(provider_id, facility_id) {
    try {
      this.loader.startLoader('loader-01');
      await this.getCensuses(provider_id, facility_id);
      this.loader.stopLoader('loader-01');
    } catch (e) {
      this.toastr.error('something went wrong in loading data', 'Error');
    }
  }

  async initAssociatedProvidersList() {
    await this.dashboardService
      .getAssociatedDoctorsList(this.currentUser.company_id)
      .subscribe(async (response: any) => {
        if (response.status === 200) {
          this.providers = response.data;
          if(this.providers.length){
              this.provider_id = this.providers[0]._id;
              this.filterFormGroup.get('provider').setValue(this.provider_id);
              await this.loadFacilities(this.provider_id);
          }
        }
      });
  }

  initAssociatedProvidersListForMA() {
    this._transcriptionCreateService
      .getAssociatedDoctorsListForMA()
      .subscribe(async (response: any) => {
        if (response.status === 200) {
          this.providers = response.data;
          if(this.providers.length){
           // if (!this.provider_id) {
              this.provider_id = this.providers[0]._id;
              this.filterFormGroup.get('provider').setValue(this.provider_id);
              await this.loadFacilities(this.provider_id);

           // }
          }
        }
      });
  }

  initAssociatedProvidersListForBO() {
    this._transcriptionCreateService
      .getAssociatedDoctorsListForBO(this.currentUser._id, this.currentUser.company_id, this.currentUser.user_type)
      .subscribe(async (response: any) => {
        if (response.status === 200) {
          this.providers = response.data;
          if(this.providers.length){
           // if (!this.provider_id) {
              this.provider_id = this.providers[0]._id;
              this.filterFormGroup.get('provider').setValue(this.provider_id);
              await this.loadFacilities(this.provider_id);

           // }
          }
        }
      });
  }

  async viewClicked(census_id) {
    if(!(this.facility_id == '' || this.facility_id == null)) {
      this.censusOpened = true;
      localStorage.setItem('censusCalendarFacility',JSON.stringify(this.facility_id));
    }
    localStorage.setItem('hide_census', 'false')
    let pro;
    if (this.providerIdParam) {
      const userDetailResponse: any = await this.dashboardService.getUserDetail(this.providerIdParam).toPromise();
      if (userDetailResponse.status == 200) {
        pro = userDetailResponse.data;
      }
    }
    let telemedicine = pro[0]?.other_settings?.show_telemedicine || 'false';
    if (this.admin) {
      this.router.navigateByUrl(`/admin/census/${census_id};telemedicine=${telemedicine}`, { relativeTo: this.route });
    }
    if (this.company) {
      this.router.navigateByUrl(`/company/${this.currentUser.company_id}/census/${census_id};telemedicine=${telemedicine}`, { relativeTo: this.route });
    }
    else {
      localStorage.setItem('calView', 'true');
      this.router.navigateByUrl(`/census/${census_id};telemedicine=${telemedicine}`);
    }
  }

  //   async initProviders() {
  //     this.providerIdParam = this.route.snapshot.params.provider_id;
  //     if (this.providerIdParam) {
  //       this.filter_provider_id = this.providerIdParam;
  //     }
  //     if (this.currentUser.user_type == global.USER_TYPE.DOCTOR) {
  //       let response: any = await this.dashboardService.getP2PRelation().toPromise()
  //       if (response.status == 200) {
  //         this.providers = [this.currentUser].concat(response.data.assoc_provider_id);

  //         this.providers = this.providers.map(d => ({ ...d, name: `${d.first_name} ${d.last_name}, ${d.title}` }));
  //         if (this.filter_provider_id) {
  //           let filtered_provider = this.providers.filter(item => item._id == this.filter_provider_id)
  //           if (filtered_provider) {
  //             this.filter_provider_id = filtered_provider[0]._id
  //             return
  //           }

  //         }
  //         if (!this.filter_provider_id) {
  //           this.filter_provider_id = this.providers[0]._id;
  //         }
  //       }
  //     }

  //     // else if (this.currentUser.user_type == global.USER_TYPE.MEDICAL_ASSISTANT) {
  //     //   this.initAssociatedProvidersListForMA();
  //     // }
  //     // else if (this.currentUser.user_type == global.USER_TYPE.BUSINESS_OFFICER) {
  //     //   //console.log('userrrrr', this.currentUser);
  //     //   this.initAssociatedProvidersListForBO();
  //     // }
  //     // else {
  //     //   this.initAssociatedProvidersList();
  //     // }
  //   }

  //   initAssociatedProvidersList() {
  //     this.dashboardService
  //       .getAssociatedDoctorsList(this.currentUser.company_id)
  //       .subscribe((response: any) => {
  //         if (response.status === 200) {
  //           this.providers = response.data;
  //           if (this.filter_provider_id) {
  //             this.initFacilities(null, this.filter_provider_id);
  //           }
  //           else {
  //             this.initFacilities();
  //           }
  //           this.providers = this.providers.map(d => ({ ...d, name: `${d.first_name} ${d.last_name}, ${d.title}` }));
  //           if (!this.filter_provider_id) {
  //             this.filter_provider_id = this.providers[0]._id;
  //           }
  //         }
  //       });
  //   }

  //   initAssociatedProvidersListForMA() {
  //     this._transcriptionCreateService
  //       .getAssociatedDoctorsListForMA()
  //       .subscribe((response: any) => {
  //         if (response.status === 200) {
  //           this.providers = response.data;
  //           if (this.providers?.length > 0) {
  //             const providerId = this.filter_provider_id || this.providers[0]._id;
  //             this.initFacilities(null, providerId);
  //           }
  //           if (this.providers?.length > 0) {
  //             this.providers = this.providers.map(d => ({ ...d, name: `${d.first_name} ${d.last_name}, ${d.title}` }));
  //             if (!this.filter_provider_id) {
  //               this.filter_provider_id = this.providers[0]._id;
  //             }
  //           }
  //         }
  //       });
  //   }

  //   initAssociatedProvidersListForBO() {
  //     this._transcriptionCreateService
  //       .getAssociatedDoctorsListForBO(this.currentUser._id, this.currentUser.company_id, this.currentUser.user_type)
  //       .subscribe((response: any) => {
  //         if (response.status === 200) {
  //           this.providers = response.data;
  //           if (this.providers?.length > 0) {
  //             const providerId = this.filter_provider_id || this.providers[0]._id;
  //             this.initFacilities(null, providerId);
  //           }
  //           if (this.providers?.length > 0) {
  //             this.providers = this.providers.map(d => ({ ...d, name: `${d.first_name} ${d.last_name}, ${d.title}` }));
  //             if (!this.filter_provider_id) {
  //               this.filter_provider_id = this.providers[0]._id;
  //             }
  //           }
  //         }
  //       });
  //   }

  // initFacilities(selectedProvider = null, provider_id?) {
  //   if (!this.filter_facility_id && this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT || this.currentUser.user_type === global.USER_TYPE.TRANSCRIBER) {
  //     if (this.providers?.length > 0) {
  //       selectedProvider = this.providers[0]._id;
  //     }
  //     else return;
  //   }
  //   if (provider_id) selectedProvider = provider_id;
  //   this.facilities = []
  //   this.addressSubscription = this.facilityService.getMyFacilities(null, selectedProvider).subscribe((response: any) => {
  //     if (response.status == 200) {
  //       this.facilities = response.data.array;
  //       this.facilities.sort((a, b) => a.title.toLowerCase().localeCompare(b.title.toLowerCase()));
  //       this.selectedFacility = this.facilities.find(f => f._id === this.filter_facility_id);
  //       if (!this.selectedFacility) {
  //         this.pccService.pccUserinfo$.subscribe(u => {
  //           if (u) {

  //             const selectedFacility = this.facilities.find(f => this.isDefaultLoggedInFacility(f));
  //             if (selectedFacility && this.selectedFacility?._id !== selectedFacility._id) {
  //               this.selectedFacility = selectedFacility;
  //               this.filter_facility_id = this.selectedFacility._id;
  //               this.handleFilterFacilityChange();
  //             }
  //           } else {
  //             this.selectedFacility = this.facilities[0];
  //             this.filter_facility_id = this.facilities[0]._id;
  //             this.handleFilterFacilityChange();
  //           }
  //         });
  //       } else {
  //         this.facility_charge_capture_enabled = this.selectedFacility.enabled_charge_capture;
  //         if ((this.currentUser.user_type === global.USER_TYPE.TRANSCRIBER || this.currentUser.user_type === global.USER_TYPE.DOCTOR) && (!this.facility_charge_capture_enabled || !this.user_charge_capture_enabled)) {
  //           this.displayedColumns.splice(this.displayedColumns.indexOf('draft_submitted_charges'), 1);
  //           this.displayedColumns.splice(this.displayedColumns.indexOf('status'), 1);
  //         }
  //         else if (this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT) {
  //           this.displayedColumns = this.displayedColumns.filter(column => column !== 'saved_signed_notes' && column !== 'draft_submitted_charges' && column !== 'status');
  //         }
  //       }
  //       if (this.currentUser.user_type === global.USER_TYPE.MEDICAL_ASSISTANT)
  //         this.initPatientRoundingSheets(this.filter_facility_id, this.filter_provider_id, this.showLimit);
  //     }
  //   });
  // }




}
